// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMndR","nav__left":"Nav_nav__left__QMzvh","nav__right":"Nav_nav__right__soSwy","index":"Nav_index__ZFSI-","about":"Nav_about__PFJ2U","signin":"Nav_signin__UZ0qs"};